import {DropdownMenuItemType, MenuItemsType} from '@pancakeswap/uikit'
import {ContextApi} from '~/contexts/Localization/types'


export type ConfigMenuItemsType = MenuItemsType & { hideSubNav?: boolean }

const menuConfig: (t: ContextApi['t']) => ConfigMenuItemsType[] = (t) => [

  {
    label: '',
    href: '/',
    icon: 'More',
    hideSubNav: true,
    items: [
      {
        label: t('Blog'),
        href: 'https://medium.com/@shimmerseadefi',
        type: DropdownMenuItemType.EXTERNAL_LINK,
      },
    ],
  },
]

const config = {
  menuConfig,
  showMLUM: false,
  showLUM: false,
  showSMR: false
}

export default config
